import React, { useEffect, useReducer } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { getUserRoadblocks } from './Services/getUserRoadBlocks';
import { tasksReducer, initialState } from './tasksReducer';
import { useSelector } from 'react-redux';
import { getSubStringId } from '../../Common/SubStringConvert';
import { useWebProperties } from '../../Common/webProperties';
import convertPSTtoLocalTime from '../../Common/convertPSTtoLocalTime';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        width: '100%',
        padding: theme.spacing(2, 4, 3),
    },
}));

// user document model and immigration admin model also
export default function RoadBlockModal(props) {
    const classNames = useStyles();
    const [state, dispatch] = useReducer(tasksReducer, initialState)
    const getUser = useSelector(state => state.auth)
    const { ROADBLOCK_DESCRIPTION, REQUESTED_BY, ASSIGNED_DATE, ASSIGNED_TO,
        ASSIGNED_BY, MAINTASKNAME, MAINTASK, MAINTASK_DESCRIPTION, ROADBLOCK_LIST } = useWebProperties();
    useEffect(() => {
        getUserRoadblocks(dispatch, getUser.user, props.data.id);
        // eslint-disable-next-line
    }, [])
    // console.log(state.userRoadblock)
    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classNames.modal}
                open={props.open}
                onClose={props.handleClose}
                closeAfterTransition
                disableBackdropClick={true}
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={props.open}>
                    <div className={classNames.paper}>
                        <div className="user-modal-dialog d-flex justify-content-center" style={{height:'500px'}}>
                            <div className="modal-content col-lg-6 col-sm-12 p-2" style={{ borderRadius: '10px' }}>
                                <div class="modal-header" style={{ backgroundColor: '#D2ECDF' }}>
                                    <div className="column">
                                        <h5 class="modal-title p-1">{ROADBLOCK_LIST}</h5>
                                    </div>
                                </div>
                                <div className="modal-body overflow-auto">
                                    <h6 className="text-dark mb-0">{MAINTASK} ID :{getSubStringId(getUser.user.corp, 3)}-{props.data.us_id}</h6>
                                    <p className="text-dark mb-0">{MAINTASKNAME} : {props.data.title} </p>
                                    <p className="text-dark mb-1">{MAINTASK_DESCRIPTION} : {props.data.description || props.data.taskDesc} </p>

                                    {state.userRoadblock.length > 0 ? state.userRoadblock.map((roadblock, index) => {
                                        return (
                                            
                                            <div className="overflow-auto mb-1" key={index} style={{padding: '10px',  overflow: 'auto', border: '0.2px solid grey', borderRadius: '10px' }}>
                                                <h6 className="text-dark">{MAINTASK} ID : {getSubStringId(getUser.user.corp, 3)}-{(roadblock.us_id)}</h6>
                                                <h6 className="text-success">{ROADBLOCK_DESCRIPTION} : {roadblock.roadblock_description} </h6>
                                                <p style={{fontSize:'12px'}}>{REQUESTED_BY} : {roadblock.requestedby} </p>
                                                <p style={{fontSize:'12px'}}>{ASSIGNED_DATE} : {convertPSTtoLocalTime(roadblock.roadblock_date)}</p>
                                                <p style={{fontSize:'12px'}}>{ASSIGNED_BY} : {roadblock.assignedby} </p>
                                                <p style={{fontSize:'12px'}}>{ASSIGNED_TO} : {roadblock.assignedto} </p>
                                                {/* <h5>Task {props.data.id}</h5> */}
                                            </div>)
                                    }) : null}
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-success" onClick={props.handleClose} style={{ borderRadius: '20px' }}>Ok</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div >
    );
}